import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=6086f194&"
import script from "./CalendarItem.vue?vue&type=script&lang=ts&"
export * from "./CalendarItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports